export default "__VITE_ASSET__NyTpIYYx__"